import device from 'current-device';

/* В случае расширения всей этой истории, нужно создать абстрактный js-конструктор с функционалом воспроизведения.
Возможно, стоит использовать в этом конструкторе какие-либо базовые цсс классы. И навешивать их на все подобные блоки с синтезом речи
Либо к конструктору привязываться цсс классами в каждом бэм-блоке по отдельности. */
if (window.speechSynthesis) { // Не все браузеры поддерживают speechSynthesis, поэтому если он пустой, удаляем строку с воспроизведением
    let voices = speechSynthesis.getVoices();
    let defaultVoice;
    const PLAY = 'book-page__annotation-play';
    const PAUSE = 'book-page__annotation-pause';
    const RESUME = 'book-page__annotation-resume';
    const cPlay = 'book-page__card-description_play';
    const cPause = 'book-page__card-description_pause';
    const elParent = document.querySelector('.book-page__card-description');
    const elAnnotationPlay = document.querySelector('.book-page__annotation-play');

    // eslint-disable-next-line no-inner-declarations
    function getUtterance(currentTarget, text, last = false) {
        const speechSynthesisUtterance = new SpeechSynthesisUtterance(text);

        // Если не нашли "Google русский", то ищем хоть какого-то диктора на русском
        if (!defaultVoice) {
            defaultVoice = voices.filter((item) => {
                if (item.lang === 'ru_RU' || item.lang === 'ru-RU') {
                    return item;
                }

                return '';
            });

            defaultVoice = defaultVoice[0];
        }
        //

        speechSynthesisUtterance.voice = defaultVoice;
        speechSynthesisUtterance.lang = defaultVoice.lang;
        speechSynthesisUtterance.volume = 1;
        speechSynthesisUtterance.rate = 1;
        speechSynthesisUtterance.pitch = 1;

        speechSynthesisUtterance.onstart = () => {
            currentTarget.className = PAUSE;
        };

        speechSynthesisUtterance.onend = () => {
            currentTarget.className = PLAY;

            // Если воспроизводится последний текстовый элемент массива, то нужно заменить иконку и текст кнопки
            if (last) {
                elParent.classList.remove(cPlay);
            }
            //
        };

        speechSynthesisUtterance.onerror = (err) => console.error(err);

        return speechSynthesisUtterance;
    }

    // eslint-disable-next-line no-inner-declarations
    function handleClick({ currentTarget }) {
        /* Получаем текст аннотации и разделяем его по '.:;'. Это нужно, так как диктор 'Google русский' прерывается
        при воспроизведении длинного предложения, при этом никаких ошибок нет - это просто баг SpeechSynthesisUtterance.
        Так как 'Google русский' звучит гораздо качественнее, делаем такой костыль, делящий длинные предложения на небольшие участки,
        которые мы воспроизводим друг за другом. 'Google русский' есть только в Chromium браузерах, в остальных будет Microsoft-диктор. */
        const arrAllText = elParent.querySelector('.book-page__card-description-text').textContent.split(/([.:;/])/);
        const arrAllTextNotUnnecessaryChar = [];

        // Удаляем абзацы, пробелы, проверяем что в элементе более 1 символа. Записываем результат в allTextNotUnnecessaryChar
        arrAllText.map((item) => {
            const textItem = item.trim().replace(/\s+/g, ' ');

            if (textItem.length > 1) {
                arrAllTextNotUnnecessaryChar.push(item);
            }

            return '';
        });
        //

        switch (currentTarget.className) {
        case PLAY:
            speechSynthesis.cancel();

            arrAllTextNotUnnecessaryChar.forEach((text, i) => {
                const isLastItem = i + 1 === arrAllTextNotUnnecessaryChar.length;

                /* Если после всех разделений на маленькие участки предложение всё ещё длиннее 230 символом, то сокращаем его по ', ...' */
                if (text.length > 230) {
                    const arrTextLong = text.split(/(,|\...|\/)/);

                    arrTextLong.forEach((textLong) => {
                        if (textLong && textLong.length > 1) {
                            const textFragment = getUtterance(currentTarget, textLong, isLastItem);

                            speechSynthesis.speak(textFragment);
                        }
                    });
                } else {
                    const textFragment = getUtterance(currentTarget, text, isLastItem);

                    speechSynthesis.speak(textFragment);
                }
            });

            elParent.classList.add(cPlay);
            elParent.classList.remove(cPause);
            break;
        case PAUSE:
            // android устройства на 2024 год не поддерживают паузу и воспроизведение на участке, где остановилось прослушивание
            // https://stackoverflow.com/questions/58953882/resuming-a-paused-speech-using-speechsynthesis-resume-on-chrome-android-doesn\
            // Поэтому меняем кнопку на "Остановить запись" вместо "Поставить на паузу" и при повторном нажатии
            // на воспроизведение начинаем его с самого начала
            if (device.android()) {
                currentTarget.className = PLAY;
                speechSynthesis.cancel();
                elParent.classList.remove(cPause);
                elParent.classList.remove(cPlay);
            } else {
                currentTarget.className = RESUME;
                speechSynthesis.pause();
                elParent.classList.remove(cPlay);
                elParent.classList.add(cPause);
            }

            break;
        case RESUME:
            currentTarget.className = PAUSE;
            speechSynthesis.resume();
            elParent.classList.add(cPlay);
            elParent.classList.remove(cPause);
            break;
        default:
            break;
        }
    }

    // Если 'Google русский' есть в списке возможных дикторов, выбираем его по умолчанию
    speechSynthesis.onvoiceschanged = () => {
        voices = speechSynthesis.getVoices();
        defaultVoice = voices.find((voice) => voice.name === 'Google русский');
    };
    //

    speechSynthesis.cancel();
    elAnnotationPlay?.addEventListener('click', handleClick);
} else {
    $('.book-page__annotation-play').remove();
}